export function popups() {
    $(window).on("load", function () {
        const mainWrap = $("body");

        function closePopup() {
            $(".popup").removeClass("active");
            mainWrap.removeClass("popup-open");
        }

        $(document).on("click", ".popup-link", function (event) {
            event.preventDefault();

            let $this = $(this);
            let $url = $this.attr("href");
            let parseUrl = $url.split('#');
            let $target = '#' + parseUrl[1];

            $($target).addClass("active").fadeIn(300);
            mainWrap.addClass("popup-open");

        }).on("click", ".popup-close", function () {
            closePopup.call(this);
        });

        $(".popups").on("click", function (event) {
            if (!$(event.target).closest(".popup-holder").length) {
                closePopup.call(this);
            }
        });

        //Cookie popup
        // const cookiePopup = $('#popup-cookie');
        //
        // if (cookiePopup.length && document.cookie.indexOf("RaboCorporatePrivacyLevel=") < 0) {
        //     cookiePopup.addClass("active").fadeIn(300);
        //     mainWrap.addClass("popup-open");
        //
        //     cookiePopup.find('.popup-close').on('click', function (e) {
        //         e.preventDefault();
        //
        //         let id = $(this).attr('data-consent-level');
        //         document.cookie = 'RaboCorporatePrivacyLevel=' + (id * 1) + ';max-age=2629800;path=/;domain=' + document.domain;
        //         $.post(
        //             ajaxvars.ajaxurl,
        //             {
        //                 action: 'cookies_tracking',
        //                 cookies_params: id
        //             }
        //         );
        //         closePopup.call(this);
        //     });
        // }
        //
        // $('.cookies-btn').on('click', function () {
        //     let consent_level = $(this).data('id');
        //     $('.cookies-btn').removeClass('active');
        //     $(this).addClass('active');
        //     $('#popup-cookie .popup-close').attr('data-consent-level', consent_level);
        // });

    });
}




// WEBPACK FOOTER //
// ./assets/js/modules/popups.js